// noinspection RequiredAttributes

import { html, View } from 'rune-ts';
import klass from './ProductImageView.module.scss';
import { classes, htmlIf } from '@services/MarppleShop/shared/util';
import {
  BadgeMainView,
  TBadgeMainWithoutSize,
} from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/BadgeMainView.ts';
import { LikeView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/LikeView.ts';
import { staticFont } from '@services/MarppleShop/shared/typography';
import { ProductThumbnail } from '@services/MarppleShop/features/ProductList/type';
import { thumbnailViewTransformer } from '@services/MarppleShop/renderApp/components/cells/ProductThumbnail/transform/thumbnailViewTransformer.ts';
import { pipe } from '@fxts/core';
import { makeSubScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { ELang } from '@services/MarppleShop/shared/enum/ELang.ts';
import { assert, assertIsDefined } from '@services/MarppleShop/shared/util/assert.ts';
import { CardProductError } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductView.ts';
import {
  BadgeRealtimeView,
  TBadgeRealtimeWithoutSize,
} from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/BadgeRealtimeView.ts';

export type TProps =
  | {
      state: 'Default';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Default';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      badge_realtime_without_size?: TBadgeRealtimeWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Default';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Default';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    };

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=26351-75736&m=dev
 */
export class ProductImageView extends View<TProps> {
  private likeView: LikeView = new LikeView({
    state: this.data.is_liked ? 'On' : 'Off',
    size:
      this.data.size === 'Xlarge~Large'
        ? 'Large'
        : this.data.size === 'Medium~Small' || this.data.size === 'Xsmall'
          ? 'Medium'
          : 'Small',
  });

  setIsLiked(is_liked: boolean) {
    this.data.is_liked = is_liked;
    this.likeView.setState(is_liked ? 'On' : 'Off');
  }

  setBadgeRealtimeWithoutSize(badge_realtime_without_size: TBadgeRealtimeWithoutSize) {
    assert(this.data.size === 'Xlarge~Large' || this.data.size === 'Medium~Small', new CardProductError());

    this.data.badge_realtime_without_size = badge_realtime_without_size;
    const container = this.element().querySelector(`.${klass.badge_realtime_wrapper}`);
    assertIsDefined(container, new CardProductError());
    container.replaceChildren(
      new BadgeRealtimeView({
        ...badge_realtime_without_size,
        size: this.data.size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
      }).render(),
    );
  }

  protected override onRender() {
    this.delegate('click', `.${klass.like_wrapper}`, this.data.onLikeClick);
  }

  protected override template(props: TProps) {
    const dimensions = thumbnailViewTransformer.calculateDimensions(
      props.thumbnail_info.scale,
      props.resize_width,
    );

    const img_style = thumbnailViewTransformer.createStyle(props.thumbnail_info, dimensions);

    const resized_img_url = thumbnailViewTransformer.createResizedUrl(props.thumbnail_info, dimensions);

    const img_href = `/${props.domain_name}/products/${props.id}`;

    const img_data_post_message = pipe(img_href, makeSubScreenNavigate, dataStr);

    const img_alt = `${props.store_name}, ${props.name}${T.lang === ELang.Kr ? ' 굿즈, 굿즈 판매, 굿즈샵' : ''}`;

    if (props.state === 'Default') {
      const { thumbnail_info, is_lazy, size } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: size === 'Xlarge~Large',
          [klass.size_medium_small]: size === 'Medium~Small',
          [klass.size_xsmall]: size === 'Xsmall',
          [klass.size_small]: size === 'Small',
        })}"
      >
        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_main_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
                [klass.size_xsmall]: size === 'Xsmall',
              })}"
            >
              ${props.badge_main_without_size
                ? new BadgeMainView({
                    ...props.badge_main_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}
        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_realtime_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
              })}"
            >
              ${(props.size === 'Medium~Small' || props.size === 'Xlarge~Large') &&
              props.badge_realtime_without_size
                ? new BadgeRealtimeView({
                    ...props.badge_realtime_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: size === 'Xlarge~Large',
            [klass.size_medium_small]: size === 'Medium~Small',
            [klass.size_xsmall]: size === 'Xsmall',
            [klass.size_small]: size === 'Small',
          })}"
        >
          ${this.likeView}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Adult') {
      const { thumbnail_info, is_lazy, size } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: size === 'Xlarge~Large',
          [klass.size_medium_small]: size === 'Medium~Small',
          [klass.size_xsmall]: size === 'Xsmall',
          [klass.size_small]: size === 'Small',
        })}"
      >
        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_main_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
                [klass.size_xsmall]: size === 'Xsmall',
              })}"
            >
              ${props.badge_main_without_size
                ? new BadgeMainView({
                    ...props.badge_main_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}
        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_realtime_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
              })}"
            >
              ${(props.size === 'Medium~Small' || props.size === 'Xlarge~Large') &&
              props.badge_realtime_without_size
                ? new BadgeRealtimeView({
                    ...props.badge_realtime_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: size === 'Xlarge~Large',
            [klass.size_medium_small]: size === 'Medium~Small',
            [klass.size_xsmall]: size === 'Xsmall',
            [klass.size_small]: size === 'Small',
          })}"
        >
          ${this.likeView}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Soldout') {
      const { thumbnail_info, is_lazy, size } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: size === 'Xlarge~Large',
          [klass.size_medium_small]: size === 'Medium~Small',
          [klass.size_xsmall]: size === 'Xsmall',
          [klass.size_small]: size === 'Small',
        })}"
      >
        <div
          class="${classes(
            klass.dim_soldout,
            staticFont(
              size === 'Xlarge~Large'
                ? 'bebas_32_bold'
                : size === 'Medium~Small' || size === 'Xsmall'
                  ? 'bebas_20_bold'
                  : 'bebas_16_bold',
            ),
          )}"
        >
          SOLD OUT
        </div>

        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_main_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
                [klass.size_xsmall]: size === 'Xsmall',
              })}"
            >
              ${props.badge_main_without_size
                ? new BadgeMainView({
                    ...props.badge_main_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}
        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_realtime_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
              })}"
            >
              ${(props.size === 'Medium~Small' || props.size === 'Xlarge~Large') &&
              props.badge_realtime_without_size
                ? new BadgeRealtimeView({
                    ...props.badge_realtime_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: size === 'Xlarge~Large',
            [klass.size_medium_small]: size === 'Medium~Small',
            [klass.size_xsmall]: size === 'Xsmall',
            [klass.size_small]: size === 'Small',
          })}"
        >
          ${this.likeView}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Soldout+Adult') {
      const { thumbnail_info, is_lazy, size } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: size === 'Xlarge~Large',
          [klass.size_medium_small]: size === 'Medium~Small',
          [klass.size_xsmall]: size === 'Xsmall',
          [klass.size_small]: size === 'Small',
        })}"
      >
        <div
          class="${classes(
            klass.dim_soldout,
            staticFont(
              size === 'Xlarge~Large'
                ? 'bebas_32_bold'
                : size === 'Medium~Small' || size === 'Xsmall'
                  ? 'bebas_20_bold'
                  : 'bebas_16_bold',
            ),
          )}"
        >
          SOLD OUT
        </div>

        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_main_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
                [klass.size_xsmall]: size === 'Xsmall',
              })}"
            >
              ${props.badge_main_without_size
                ? new BadgeMainView({
                    ...props.badge_main_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}
        ${size === 'Small'
          ? null
          : html`<div
              class="${classes(klass.badge_realtime_wrapper, {
                [klass.size_xlarge_large]: size === 'Xlarge~Large',
                [klass.size_medium_small]: size === 'Medium~Small',
              })}"
            >
              ${(props.size === 'Medium~Small' || props.size === 'Xlarge~Large') &&
              props.badge_realtime_without_size
                ? new BadgeRealtimeView({
                    ...props.badge_realtime_without_size,
                    size: size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
                  })
                : null}
            </div>`}

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: size === 'Xlarge~Large',
            [klass.size_medium_small]: size === 'Medium~Small',
            [klass.size_xsmall]: size === 'Xsmall',
            [klass.size_small]: size === 'Small',
          })}"
        >
          ${this.likeView}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else {
      throw new CardProductError();
    }
  }
}
